// style-loader: Adds some reference to a css file to the DOM by adding a <link> tag
var update = require("!/Users/peter/streamabc/src/skip-player/node_modules/style-loader/addStyleUrl.js")(
	require("!!../../node_modules/file-loader/index.js?name=semantic/[hash].[ext]!./semantic.min.css")
, {});
// Hot Module Replacement
if(module.hot) {
	module.hot.accept("!!../../node_modules/file-loader/index.js?name=semantic/[hash].[ext]!./semantic.min.css", function() {
		update(require("!!../../node_modules/file-loader/index.js?name=semantic/[hash].[ext]!./semantic.min.css"));
	});
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/style-loader/url.js!./~/file-loader?name=semantic/[hash].[ext]!./semantic/dist/semantic.min.css
// module id = 367
// module chunks = 0